import Tracking from "./Tracking";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function TrackingWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <Tracking />
        </XeroFeatureFlagCheck>
    )
}

export default TrackingWrapper;